<template>
  <div class="entry-main-wrapper">
    <DataLoader :is_on="fetching" />
    <div class="entry-wrapper">
      <div class="entry-header">
        <div class="entry-header-left">
          <div class="entry-icon">
            <img src="@/assets/img/nova_osoba.svg" />
          </div>
          <div class="entry-title">{{naziv_forme}}</div>
        </div>
        <div class="entry-header-right">
          <a @click="goBack()" class="entry-exit"
            ><img src="@/assets/img/entry_form_close.svg"
          /></a>
        </div>
      </div>
      <!-- end new person header -->
      <div class="main-entry-form-wrapper">
        <!-- *** VRSTA **** -->
        <form-drop-down
          label="Vrsta"
          id="vrsta"
          ref="vrstaDrop"
          :dropImport="dostupne_vrste"
          :base="edit_type"
          :disabled="is_edit ? true : false"
        ></form-drop-down>
        <FizickaOsoba
          v-if="trenutna_vrsta.ID == 1"
          :industrija="industrija"
          :tipovi_izvora="tipovi_izvora"
          :pravne="pravne"
          :fizicke="fizicke"
          :clanovi="tim"
          :invalid_elements="invalid_elements_fiz"
          ref="fizickaOsoba"
          @finished="fetching = false"
        />
        <PravnaOsoba
          v-if="trenutna_vrsta.ID == 2"
          :industrija="industrija"
          :tipovi_izvora="tipovi_izvora"
          :pravne="pravne"
          :fizicke="fizicke"
          :clanovi="tim"
          :invalid_elements="invalid_elements_pravna"
          ref="pravnaOsoba"
          @finished="fetching = false"
        />
        <Institucija
          v-if="trenutna_vrsta.ID == 3"
          :industrija="industrija"
          ref="institucija"
          :invalid_elements="invalid_elements_inst"
          @finished="fetching = false"
        />
        <PravnoTijelo v-if="trenutna_vrsta.ID == 4" ref="pravnoTijelo" :institucije="institucije" :invalid_elements="invalid_elements_legbod" @finished="fetching = false" />
        <InvalidElementsList v-if="error_list.length != 0" :error_list="error_list"/>
        <!-- *** KREIRAJ BUTTON **** -->
        <div class="button-create-wrapper" @click="!is_waiting_on_insert ? check() : ''">
          <div :style="is_waiting_on_insert ? 'background-color: gray' : 'background-color: #2a23a0'" class="button-default button-create">{{naziv_gumb}}</div>
        </div>
      </div>
    </div>
    <!-- end new case wrapper -->
  </div>
  <!-- end new case main wrapper -->
</template>
	
	<script>
import formInput from "@/components/formElements/formInput.vue";
import formTextarea from "@/components/formElements/formTextarea.vue";
import formDropDown from "@/components/formElements/formDropDown.vue";
import formAutocomplete from "@/components/formElements/formInputAutocomplete.vue";
import FizickaOsoba from "@/components/personComponents/FizickaOsoba.vue";
import PravnaOsoba from "@/components/personComponents/PravnaOsoba.vue";
import PravnoTijelo from "@/components/personComponents/PravnoTijelo.vue";
import Institucija from "@/components/personComponents/Institucija.vue";
import InvalidElementsList from "@/components/generalComponents/InvalidElementsList.vue";
import osobe from "@/apiCallers/promise_handler_db/osobe_pr";
import institutions from "@/apiCallers/promise_handler_db/institucije";
import auth from "@/services/auth";
import person from "@/apiCallers/person";
import DataLoader from '@/components/generalComponents/DataLoader'
import $ from "jquery";
import gsap from "gsap";

export default {
  data() {
    return {
      naziv_forme: 'Unesi novu osobu',
      naziv_gumb: 'Kreiraj osobu',
      is_waiting_on_insert:false,
      is_edit: false,
      error_list: [],
      invalid_elements_fiz: {
        ime: false,
        prezime: false,
        izvor: false,
        custom_ime_izvora: false,
      },
      invalid_elements_pravna:{
        tvrtka:false,
        izvor:false,
        custom_ime_izvora:false,
      },
      invalid_elements_inst:{
        naziv:false,
      },
      invalid_elements_legbod:{
        ime:false,
        prezime:false,
      },
      dostupne_vrste: [
        { id: 1, naziv: "Fizička osoba" },
        { id: 2, naziv: "Pravna osoba" },
        { id: 3, naziv: "Institucija" },
        { id: 4, naziv: "Osobe postupka" },
      ],
      edit_type: {},
      trenutna_vrsta: 1,
      industrija: [],
      tipovi_izvora: [
        { id: 1, naziv: "Fizička osoba" },
        { id: 2, naziv: "Pravna osoba" },
        { id: 3, naziv: "Član tima" },
        { id: 4, naziv: "Izvor izvan sustava" },
        { id: 5, naziv: "Nema izvora" },
      ],
      fizicke: [],
      tim: [],
      pravne: [],
      institucije: [],
      fetching: true,
    };
  },
  watch:{
    'trenutna_vrsta.ID':function(){
      if (!this.is_edit) {
        switch (this.$refs.vrstaDrop.$data.ID) {
          case 1:
            this.naziv_forme = 'Unesi novu fizičku osobu';
            this.naziv_gumb = 'Kreiraj osobu'
            break;
          case 2:
            this.naziv_forme = 'Unesi novu pravnu osobu';
            this.naziv_gumb = 'Kreiraj osobu'
            break;
          case 3:
            this.naziv_forme = 'Unesi novu instituciju';
            this.naziv_gumb = 'Kreiraj instituciju';
            break;
          case 4:
            this.naziv_forme = 'Unesi novog sudionika';
            this.naziv_gumb = 'Kreiraj osobu';
            break;       
          default:
            break;
        }
      }
    }
  },
  methods: {
    goBack() {
      this.$router.go(-1);
    },
    validate_fizicka(){
      this.error_list = [];
      this.invalid_elements_fiz = {
        ime: false,
        prezime: false,
        izvor: false,
        custom_ime_izvora: false,
      };
      let data = this.$refs.fizickaOsoba.$data.fizicka;
      let prepared_izvor = parseInt(data.izvor_osoba.results_final.uid);
      if (data.ime.value == "") {
        this.error_list.push("Potrebno je unijeti ime osobe");
        this.invalid_elements_fiz.ime = true;
      }
      if (data.prezime.value == "") {
        this.error_list.push("Potrebno je unijeti prezime osobe");
        this.invalid_elements_fiz.prezime = true;
      }
      if (data.id_tip_izvora.ID <= 3 && isNaN(prepared_izvor)) {
        this.error_list.push(
          "Ako je odabran tip izvora potrebno je navesti ime izvor osobe"
        );
        this.invalid_elements_fiz.izvor = true;
      }
      if (data.id_tip_izvora.ID == 4 && data.custom_ime_izvora.value == "") {
        this.error_list.push(
          "Ako je izvor izvan sustava potrebno je unijeti ime i prezime osobe"
        );
        this.invalid_elements_fiz.custom_ime_izvora = true;
      }
      console.log(this.error_list);
      console.log(this.invalid_elements_fiz);
    },
    validate_pravna(){
      this.error_list = [];
      this.invalid_elements_pravna={
        tvrtka:false,
        izvor:false,
        custom_ime_izvora:false,
      }
      let data = this.$refs.pravnaOsoba.$data.pravna;
      let prepared_izvor = parseInt(data.izvor_osoba.results_final.uid);
      if (data.tvrtka.value == "") {
        this.error_list.push("Potrebno je unijeti naziv pravne osobe");
        this.invalid_elements_pravna.tvrtka = true;
      }
      if (data.id_tip_izvora.ID <= 3  && isNaN(prepared_izvor)) {
        this.error_list.push("Ako je odabran tip izvora potrebno je navesti ime izvor osobe")
        this.invalid_elements_pravna.izvor = true;
      }
      if (data.id_tip_izvora.ID == 4  && data.custom_ime_izvora.value =="") {
        this.error_list.push("Ako je izvor izvan sustava potrebno je unijeti ime i prezime osobe")
        this.invalid_elements_pravna.custom_ime_izvora = true;
      }
      console.log(this.error_list);
      console.log(this.invalid_elements_pravna)
    },
    validate_institucija(){
      this.error_list = [];
      this.invalid_elements_inst={
        naziv:false,
      }
      let data = this.$refs.institucija.$data.institucija;
      if (data.naziv.value == "") {
        this.error_list.push("Potrebno je unijeti naziv institucije");
        this.invalid_elements_inst.naziv = true;
      }
      console.log(this.error_list);
      console.log(this.invalid_elements_inst)
    },
    validate_legal_body(){
      this.error_list = [];
      this.invalid_elements_legbod={
        ime:false,
        prezime:false,
      }
      let data = this.$refs.pravnoTijelo.$data.pravnoTijelo;
      if (data.ime.value == "") {
        this.error_list.push("Potrebno je unijeti ime osobe");
        this.invalid_elements_legbod.ime = true;
      }
      if (data.prezime.value == "") {
        this.error_list.push("Potrebno je unijeti prezime osobe");
        this.invalid_elements_legbod.prezime = true;
      }
      console.log(this.error_list);
      console.log(this.invalid_elements_fiz)
    },
    edit_create_fizicka() {
      let data = this.$refs.fizickaOsoba.$data.fizicka;
      let prepared_izvor = parseInt(data.izvor_osoba.results_final.uid);
      this.validate_fizicka();
      let fizicka = {
        ime: data.ime.value,
        prezime: data.prezime.value,
        OIB: data.oib.value != "" ? data.oib.value : null,
        email: data.email_list.length != 0 ? data.email_list.values : null,
        brojevi_telefona:
          data.tel_br_list.length != 0 ? data.tel_br_list.values : null,
        adrese:
          data.adrese_list.lista_adresa.length != 0
            ? data.adrese_list.lista_adresa
            : null,
        web_stranice: data.web_list.length != 0 ? data.web_list.values : null,
        industrija: parseInt(data.industrija_id.ID),
        godisnji_prihod:
          data.god_prihod.value != "" ? data.god_prihod.value : null,
        tip_izvora: parseInt(data.id_tip_izvora.ID),
        izvor_fizicka_osoba:
          parseInt(data.id_tip_izvora.ID) == 1
            ? !isNaN(prepared_izvor)
              ? prepared_izvor.toString()
              : null
            : null,
        izvor_pravna_osoba:
          parseInt(data.id_tip_izvora.ID) == 2
            ? !isNaN(prepared_izvor)
              ? prepared_izvor.toString()
              : null
            : null,
        izvor_team:
          parseInt(data.id_tip_izvora.ID) == 3
            ? !isNaN(prepared_izvor)
              ? prepared_izvor.toString()
              : null
            : null,
        custom_ime_izvora:
          parseInt(data.id_tip_izvora.ID) == 4
            ? data.custom_ime_izvora.value != ""
              ? data.custom_ime_izvora.value
              : null
            : null,
        radno_vrijeme:
          data.radno_vrijeme.value != "" ? data.radno_vrijeme.value : null,
        opis: data.opis.value != "" ? data.opis.value : null,
        rodjendan: data.rodjendan != "" ? new Date(data.rodjendan) : undefined,
        team_filled: this.$store.state.logged_in_user.uid,
      };
      console.log(fizicka);
      if (this.error_list.length == 0) {
        this.fetching = true;
        this.is_waiting_on_insert = true;
        if (this.is_edit) {
          osobe
            .updateFizicka(fizicka, this.$router.history.current.params.oib)
            .then((response) => {
              console.log(response);
              this.fetching = false;
              this.is_waiting_on_insert = false;
              this.$router.push('/osobe/fiz/'+response.data);
            });
        } else {
          osobe.insertFizicka(fizicka).then((response) => {
            console.log(response)
            this.is_waiting_on_insert = false;
            this.fetching = false;
            this.$router.push('/osobe/fiz/'+response.data.uid);
          });
        }
      }
    },
    edit_create_pravna() {
      let data = this.$refs.pravnaOsoba.$data.pravna;
      let prepared_izvor = parseInt(data.izvor_osoba.results_final.uid);
      this.validate_pravna();
      let pravna = {
        naziv_tvrtke: data.tvrtka.value,
        OIB: data.oib.value != "" ? data.oib.value : null,
        email: data.email_list.length != 0 ? data.email_list.values : null,
        brojevi_telefona:
          data.tel_br_list.length != 0 ? data.tel_br_list.values : null,
        adrese:
          data.adrese_list.lista_adresa.length != 0
            ? data.adrese_list.lista_adresa
            : null,
        web_stranice: data.web_list.length != 0 ? data.web_list.values : null,
        industrija: parseInt(data.industrija_id.ID),
        godisnji_prihod:
          data.god_prihod.value != "" ? data.god_prihod.value : null,
        tip_izvora: parseInt(data.id_tip_izvora.ID),
        izvor_fizicka_osoba:
          parseInt(data.id_tip_izvora.ID) == 1
            ? !isNaN(prepared_izvor)
              ? prepared_izvor
              : null
            : null,
        izvor_pravna_osoba:
          parseInt(data.id_tip_izvora.ID) == 2
            ? !isNaN(prepared_izvor)
              ? prepared_izvor
              : null
            : null,
        izvor_team:
          parseInt(data.id_tip_izvora.ID) == 3
            ? !isNaN(prepared_izvor)
              ? prepared_izvor
              : null
            : null,
        custom_ime_izvora:
          parseInt(data.id_tip_izvora.ID) == 4
            ? data.custom_ime_izvora.value != ""
              ? data.custom_ime_izvora.value
              : null
            : null,
        radno_vrijeme:
          data.radno_vrijeme.value != "" ? data.radno_vrijeme.value : null,
        opis: data.opis.value != "" ? data.opis.value : null,
        team_filled: this.$store.state.logged_in_user.uid,
      };
      if (this.error_list.length == 0) {
        this.fetching = true;
        this.is_waiting_on_insert = true;
        if (this.is_edit) {
          osobe
            .updatePravna(pravna, this.$router.history.current.params.oib)
            .then((response) => {
              this.fetching = false;
              this.$router.push('/osobe/prav/'+response.data);
            }).catch((e)=>{
              this.fetching = false;
              this.is_waiting_on_insert = false;
            });
        } else {
          osobe.insertPravna(pravna).then((response) => {
            this.fetching = false;
            this.$router.push('/osobe/prav/'+response.data.uid);
          }).catch((e)=>{
            this.fetching = false;
            this.is_waiting_on_insert = false;
            });
        }
      }
    },
    edit_create_institution() {
      let data = this.$refs.institucija.$data.institucija;
      this.validate_institucija();
      let institucija = {
        naziv: data.naziv.value,
        OIB: data.oib.value != "" ? data.oib.value : null,
        email: data.email_list.length != 0 ? data.email_list.values : null,
        brojevi_telefona:
          data.tel_br_list.length != 0 ? data.tel_br_list.values : null,
        adrese:
          data.adrese_list.lista_adresa.length != 0
            ? data.adrese_list.lista_adresa
            : null,
        web_stranice: data.web_list.length != 0 ? data.web_list.values : null,
        radno_vrijeme:
          data.radno_vrijeme.value != "" ? data.radno_vrijeme.value : null,
        opis: data.opis.value != "" ? data.opis.value : null,
      };
      if (this.error_list.length == 0) {
      this.fetching = true;
        this.is_waiting_on_insert = true;
        if (this.is_edit) {
          institutions.updateInstitucija(institucija, this.$router.history.current.params.oib).then((resp) => {
            this.fetching = this.fetching = false;
            this.$router.push('/osobe/institucije/'+resp.data);
          }).catch((e)=>{
              this.fetching = false;
              this.is_waiting_on_insert = false;
            });
        } else {
          institutions.addInstitucija(institucija).then((resp) => {
              this.fetching = false;
              this.$router.push('/osobe/institucije/'+resp.data.uid);
          }).catch((e)=>{
              this.fetching = false;
              this.is_waiting_on_insert = false;
            });
        }
      }
    },
    edit_create_legal() {
      let data = this.$refs.pravnoTijelo.$data.pravnoTijelo;
      this.validate_legal_body();
      let pravnoTijelo = {
        ime: data.ime.value,
        prezime: data.prezime.value,
        email: data.email_list.length != 0 ? data.email_list.values : null,
        brojevi_telefona:
          data.tel_br_list.length != 0 ? data.tel_br_list.values : null,
        adrese:
          data.adrese_list.lista_adresa.length != 0
            ? data.adrese_list.lista_adresa
            : null,
        radno_vrijeme:
          data.radno_vrijeme.value != "" ? data.radno_vrijeme.value : null,
        web_stranice: data.web_list.length != 0 ? data.web_list.values : null,
        opis: data.opis.value != "" ? data.opis.value : null,
        nadlezna_institucija: !isNaN(
          parseInt(data.institucija.results_final.uid)
        )
          ? parseInt(data.institucija.results_final.uid)
          : null,
        team_filled: this.$store.state.logged_in_user.uid,
      };
      if (this.error_list.length == 0) {
        this.fetching = true;
        this.is_waiting_on_insert = true;
        if (this.is_edit) {
          osobe.update_legal_body(pravnoTijelo, this.$router.history.current.params.oib).then((resp) => {
            this.fetching = false;
            this.$router.push('/osobe/leg-body/'+resp.data);
          }).catch((e)=>{
              this.fetching = false;
              this.is_waiting_on_insert = false;
            });
        } else {
          osobe.create_legal_body(pravnoTijelo).then((resp) => {
            this.fetching = false;
            this.$router.push('/osobe/leg-body/'+resp.data.uid);
          }).catch((e)=>{
              this.fetching = false;
              this.is_waiting_on_insert = false;
            });
        }
      }
    },
    check() {
      if (this.$refs.fizickaOsoba != undefined) {
        this.edit_create_fizicka();
      }
      if (this.$refs.pravnaOsoba != undefined) {
        this.edit_create_pravna();
      }
      if (this.$refs.institucija != undefined) {
        this.edit_create_institution();
      }
      if (this.$refs.pravnoTijelo != undefined) {
        this.edit_create_legal();
      }
    },
  },

  async created() {
    this.accessToken = await auth.acquireToken(process.env.GRAPH_SCOPES);
    console.log(this.accessToken);
    let route_name = this.$router.history.current.name;
    switch (route_name) {
      case "PhisicalPersonEdit":
        this.$refs.vrstaDrop.$data.ID = 1;
        this.is_edit = true;
        this.naziv_forme = 'Ažuriranje fizičke osobe';
        this.naziv_gumb = 'Ažuriraj osobu'
        break;
      case "LegalPersonEdit":
        this.$refs.vrstaDrop.$data.ID = 2;
        this.is_edit = true;
        this.naziv_forme = 'Ažuriranje pravne osobe';
        this.naziv_gumb = 'Ažuriraj osobu'
        break;
      case "InstitutionEdit":
        this.$refs.vrstaDrop.$data.ID = 3;
        this.is_edit = true;
        this.naziv_forme = 'Ažuriranje institucije';
        this.naziv_gumb = 'Ažuriraj instituciju'
        break;
      case "LegalBodyEdit":
        this.$refs.vrstaDrop.$data.ID = 4;
        this.is_edit = true;
        this.naziv_forme = 'Ažuriranje drugog sudionika';
        this.naziv_gumb = 'Ažuriraj osobu'
        break;
      default:
        this.fetching = false;
        this.$refs.vrstaDrop.$data.ID = this.$store.state.vrsta_osobe;
        this.$store.state.vrsta_osobe = 1;
        break;
    }
  },

  components: {
    "form-input": formInput,
    "form-textarea": formTextarea,
    "form-drop-down": formDropDown,
    "form-autocomplete": formAutocomplete,
    FizickaOsoba,
    PravnaOsoba,
    PravnoTijelo,
    Institucija,
    InvalidElementsList,
    DataLoader
  },

  mounted() {
    document.body.classList.add("new-entry");
    //zašto je to tu?
    this.trenutna_vrsta = this.$refs.vrstaDrop.$data;
    //close anim
    $(".entry-exit").hover(
      function () {
        gsap.to($(this).find("img"), 0.3, {
          rotation: 180,
          transformOrigin: "center",
        });
      },
      function () {
        gsap.to($(this).find("img"), 0.5, {
          rotation: -180,
          transformOrigin: "center",
        });
      }
    );
    osobe.getAllIndustries().then((resp) => {
      this.industrija = resp.data;
      console.log(this.industrija);
    });
    osobe.getAllStrankeProtustranke().then((resp) => {
      //console.log(resp.data);
      // this.industrija = resp.data
    });
    institutions.getAllInstitucijeShort().then((resp) => {
      this.institucije = resp.data;
    });
    osobe.getAllFizLeg().then((resp) => {
      this.pravne = resp.data.all_osobe.filter((item) => item.is_fiz == false);
      this.fizicke = resp.data.all_osobe.filter((item) => item.is_fiz == true);
      this.tim = resp.data.all_pravnici;
      console.log(resp.data);
    });
  },
  updated() {},
  destroyed() {
    document.body.classList.remove("new-entry");
    $(".entry-exit").off();
  },
};
</script>
	